import { makeStyles, Theme, Typography } from '@freighthub/silhouette-core'
import { FC } from 'react'

interface TimeProps {
  time: string
  preLabel?: string
  postLabel?: string
}

interface TimeLabelProps {
  label: string
}

const useStyles = makeStyles<Theme>((theme) => ({
  estimate: {
    color: theme.palette.text.secondary,
  },
}))

export const TransportTime: FC<TimeProps> = ({ preLabel, postLabel, time }) => {
  return (
    <div>
      {preLabel && <TimeLabel label={preLabel} />}
      <div>{time}</div>
      {postLabel && <TimeLabel label={postLabel} />}
    </div>
  )
}
const TimeLabel: FC<TimeLabelProps> = ({ label }) => {
  const classes = useStyles()
  return <Typography classes={classes.estimate}>{label}</Typography>
}
